"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocale = exports.languageToDateFormat = exports.languageToLocale = void 0;
var locale_1 = require("date-fns/locale");
var R = __importStar(require("../utils/ramda"));
exports.languageToLocale = {
  cs: locale_1.cs,
  de: locale_1.de,
  en: locale_1.enUS,
  es: locale_1.es,
  fr: locale_1.fr,
  pl: locale_1.pl,
  zh: locale_1.zhCN,
  ja: locale_1.ja,
  pt: locale_1.pt
};
exports.languageToDateFormat = {
  cs: "d. MMMM yyyy",
  de: "d. MMMM yyyy",
  en: "MMMM d, yyyy",
  es: "d [de] MMMM [de] yyyy",
  fr: "d MMMM yyyy",
  pl: "d MMMM yyyy",
  zh: "yyyy年MMMMD日",
  pt: "d [de] MMMM [de] yyyy",
  ja: "yyyy年M月D日"
};
var getLocale = function (locale) {
  if (locale === void 0) {
    locale = locale_1.enUS;
  }
  if (R.type(locale) === "String") {
    if (Object.keys(exports.languageToLocale).includes(locale)) {
      return exports.languageToLocale[locale];
    } else {
      throw new Error("Invalid locale string: ".concat(locale));
    }
  }
  return locale;
};
exports.getLocale = getLocale;